import Swal from 'sweetalert2';
import { vuetify } from '@/plugins/vuetify'

function temaAtual() {
	return vuetify.theme.themes.value[vuetify.theme.global.name.value].colors
}


export const ConfirmacaoAlert = ({
	title,
	message,
	onConfirm,
	onCancel = () => false,
	confirmText = "Confirmar",
	cancelText = "Cancelar",
	showCancelButton = true,
}) => new Swal({
	title,
	text: message,
	showCancelButton,
	confirmButtonColor: temaAtual().primary,
	cancelButtonColor: temaAtual().error,
	background: temaAtual().backGroundVueSwal,
	color: temaAtual().textoVueSwal,
	confirmButtonText: confirmText,
	cancelButtonText: cancelText,
	color: temaAtual().textoVueSwal,
}).then((result) => {
	if (result.isConfirmed) {
		onConfirm();
	}
	else {
		onCancel();
	}
});

export const ConfirmacaoAndCloseAlert = (title, message, confirmText, onConfirm, icone = "error") => {
	new Swal({
		title,
		text: message,
		icon: icone,
		showCancelButton: false,
		confirmButtonColor: temaAtual().primary,
		cancelButtonColor: temaAtual().error,
		background: temaAtual().backGroundVueSwal,
		color: temaAtual().textoVueSwal,
		confirmButtonText: confirmText || "Confirmar",
		onClose: onConfirm,
	}).then(() => {
		onConfirm();
	});
};

const swalParamsDefault = {
	title: "Alerta",
	text: "",
	icon: "warning",
	confirmButtonText: "OK",
	confirmButtonColor: temaAtual().primary,
	cancelButtonColor: temaAtual().error,
};

export const AlertBase = ({
	mensagem, html, erro, swalParams = swalParamsDefault,
} = {}) => {
	let erroResponse = null;
	if (erro?.response?.data != null) {
		erroResponse = erro.response.data;
		if (erroResponse.tipoAlerta == "ATENCAO") {
			swalParams.title = "Atenção";
			swalParams.icon = "warning";
		}
		if (erroResponse.tipoAlerta == "ERRO") {
			swalParams.title = "Erro";
			swalParams.icon = "error";
		}
		if (erroResponse.tipoAlerta == "SUCESSO") {
			swalParams.title = "Sucesso";
			swalParams.icon = "success";
		}
	}
	let msg = erroResponse?.mensagem ? erroResponse.mensagem : mensagem;
	if (erro) {
		console.error(erro);
	}
	else if (msg == null || msg.trim() == "") {
		console.warn("Não foi informada uma mensagem para o modal de erro, exibindo o default.");
		msg = "Ocorreu um erro inesperado!";
	}
	if (swalParams.icon == "error") {
		console.error(msg);
	}
	else if (swalParams.icon == "warning") {
		console.warn(msg);
	}
	else {
		console.info(msg);
	}
	const swalParamsMod = swalParams;
	swalParamsMod.text = msg;
	if (html || erroResponse?.tipoMensagem == "HTML") {
		swalParamsMod.text = null;
		swalParamsMod.html = html || erroResponse.mensagem;
	}
	swalParamsMod.confirmButtonColor = temaAtual().primary;
	swalParamsMod.cancelButtonColor = temaAtual().error;
	swalParamsMod.background = temaAtual().backGroundVueSwal;
	swalParamsMod.color = temaAtual().textoVueSwal;
	new Swal(swalParamsMod);
};

export const ErroAlert = (params) => {
	const params2 = params;
	params2.swalParams = swalParamsDefault;
	params2.swalParams.title = params.titulo || "Erro";
	params2.swalParams.icon = "error";
	const currentdate = new Date();
	AlertBase(params2);
};

export const SucessoAlert = (params) => {
	const params2 = params;
	params2.swalParams = swalParamsDefault;
	params2.swalParams.title = params.titulo || "Sucesso";
	params2.swalParams.icon = "success";
	params2.swalParams.footer = null;
	AlertBase(params2);
};

export const AtencaoAlert = (params) => {
	const params2 = params;
	params2.swalParams = swalParamsDefault;
	params2.swalParams.title = params.titulo || "Atenção";
	params2.swalParams.icon = "warning";
	params2.swalParams.footer = null;
	AlertBase(params2);
};
